// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ucxIp","switch":"styles_switch__JuJbT","slider":"styles_slider__vJX6p"};